/*
  Backtrack Quote List - Backtrack Railway Services
  Built 2026-08-15. Rev 8.

  PURPOSE
  Products tagged `hide_price_and_atc` hide their price and Add to Cart from
  logged-out visitors. Before this file existed those products were a dead end,
  and the request page reads its list FROM the cart, so roughly two-thirds of
  the catalogue was invisible to the quote flow.

  WHY NOT JUST USE THE CART
  Gated products have real prices in Shopify; they are hidden by the theme, not
  absent from the data. snippets/cart-item.liquid is stock Empire and prints the
  unit price, line total and subtotal with no check for who is looking. Putting
  a gated item in the cart would display the very price the gate exists to hide.
  This list lives in the browser and never enters the Shopify cart.

  REV 2  Cart and quote lines share one table on the request page.
  REV 3  Cart quantities editable in place; the form persists as they type.
  REV 4  MY LIST = cart + quote; Checkout = cart only.
  REV 5  Hold notice for orders containing gated lines.
  REV 6  Mobile header injection of My List.
  REV 7  Both lists clear after a successful submit.
  REV 8  THE MOBILE LINK NEVER SHOWED. Found on a phone after go-live.
         desktopListVisible asked "is a Liquid-rendered My List actually on
         screen?" and stood the injected mobile link down if so. But Empire
         renders site-header-actions a second time inside the hamburger panel,
         and a closed panel still reported client rects - so the test kept
         answering yes and the mobile link stayed hidden.
         site-header-actions.liquid now stamps data-quote-in-panel on the copy
         inside the nav panel, and that copy is excluded from the test below.
         Both selectors must stay in step.

  KNOWN LIMITS (deliberate, not defects)
  - The list and the saved form live in one browser. Neither follows the
    customer to another device, and clearing site data clears both.
  - A visitor who builds a list and then logs in will have a quote list and a
    cart side by side. Merging on login is a later pass.

  REV 9  Caption beside the cart icon reads "Cart", not "Checkout". The
         header now places language, account and cart on one row, and the
         shorter word keeps that row balanced. It also describes where the
         link actually goes: the cart, not the checkout.

  REV 10 THE SUCCESS PAGE CLEARED EVERYTHING ON EVERY LOAD. Shopify renders
         the success state from ?contact_posted=true alone, so a reload, a
         back-navigation or a bookmark of the confirmation emptied a list
         built since. The submit now records its contact[Reference], and the
         success page clears only while that record is waiting, then consumes
         it - once per submission, not once per render.

  Carried forward on any Empire upgrade. Entirely Backtrack's.
*/

(function () {
  'use strict';

  if (window.BacktrackQuoteList) return;

  var STORAGE_KEY = 'backtrack_quote_list_v1';
  var FORM_KEY = 'backtrack_quote_form_v1';
  var FORM_TTL_DAYS = 7;
  var SUBMIT_KEY = 'backtrack_quote_submit_v1';
  var SUBMIT_TTL_MINUTES = 60;
  var PRICE_PLACEHOLDER = 'To be confirmed';
  var CART_LABEL = 'Cart';
  var LIST_LABEL = 'My List';
  var LIST_URL = '/pages/request-a-quote';
  var HOLD_INSTRUCTION =
    'ORDER HELD - CONFIRM PRICING WITH CUSTOMER BEFORE PROCESSING. SHIP COMPLETE ONCE APPROVED.';

  /* Liquid-rendered hosts that count as "a My List the customer can see".
     Excludes the injected mobile link and the copy Empire renders inside the
     hamburger panel - see the REV 8 note above. */
  var VISIBLE_HOST_SELECTOR =
    '[data-quote-count-host]:not([data-quote-mobile-link]):not([data-quote-in-panel])';

  /* ---------------------------------------------------------------- storage */

  function readList() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
    refreshAll();
  }

  function sumQuantities(items) {
    return items.reduce(function (sum, item) {
      return sum + (parseInt(item.qty, 10) || 0);
    }, 0);
  }

  function totalQuantity() { return sumQuantities(readList()); }

  /* ------------------------------------------------------------- list edits */

  function addItem(entry) {
    var items = readList();
    var existing = null;

    for (var i = 0; i < items.length; i++) {
      if (String(items[i].id) === String(entry.id)) { existing = items[i]; break; }
    }

    if (existing) {
      existing.qty = (parseInt(existing.qty, 10) || 0) + (parseInt(entry.qty, 10) || 1);
    } else {
      items.push({
        id: String(entry.id),
        title: entry.title || '',
        variantTitle: entry.variantTitle || '',
        sku: entry.sku || '',
        url: entry.url || '',
        qty: parseInt(entry.qty, 10) || 1
      });
    }
    writeList(items);
  }

  function setQuantity(id, qty) {
    var value = parseInt(qty, 10);
    if (isNaN(value) || value < 1) value = 1;
    var items = readList();
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].id) === String(id)) { items[i].qty = value; break; }
    }
    writeList(items);
  }

  function removeItem(id) {
    writeList(readList().filter(function (item) {
      return String(item.id) !== String(id);
    }));
  }

  /* ------------------------------------------------- clearing after a submit */

  function setAllCartCounts(count) {
    var value = String(count);
    var hosts = document.querySelectorAll('[data-quote-count-host]');
    for (var i = 0; i < hosts.length; i++) hosts[i].setAttribute('data-cart-count', value);

    var counter = document.querySelector('[data-quote-total-count]');
    if (counter) counter.setAttribute('data-cart-count', value);
  }

  /* Deliberately ignores defaultPrevented: Shopify's captcha-bootstrap cancels
     every contact form submit and resubmits it itself once the captcha
     passes, so a real submit always arrives here already prevented. */
  function rememberSubmit(event) {
    var form = event.target;
    if (!form || !form.querySelector || !form.querySelector('[data-quote-form-saved]')) return;

    var refField = form.querySelector('[name="contact[Reference]"]');
    if (!refField || !refField.value) return;
    var record = { ref: refField.value, at: Date.now() };
    try { window.localStorage.setItem(SUBMIT_KEY, JSON.stringify(record)); } catch (e) {}
  }

  function takePendingSubmit() {
    var raw;
    try { raw = window.localStorage.getItem(SUBMIT_KEY); } catch (e) { return null; }
    if (!raw) return null;
    try { window.localStorage.removeItem(SUBMIT_KEY); } catch (e) {}

    var record;
    try { record = JSON.parse(raw); } catch (e) { return null; }
    if (!record || !record.ref || !record.at) return null;
    if ((Date.now() - record.at) / 60000 > SUBMIT_TTL_MINUTES) return null;
    return record;
  }

  function clearEverythingAfterSubmit() {
    if (!document.querySelector('[data-quote-form-clear]')) return false;
    if (!takePendingSubmit()) return false;

    clearForm();
    try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) {}

    fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .then(function () { setAllCartCounts(0); })
      .catch(function () {})
      .then(function () { refreshCount(); });

    return true;
  }

  /* ------------------------------------------------------------- header bits */

  function isOnScreen(element) {
    return !!element && element.getClientRects().length > 0;
  }

  function cartLinksInHeaders() {
    var found = [];
    var headers = document.querySelectorAll('header, .site-header, [data-site-header]');

    for (var h = 0; h < headers.length; h++) {
      var links = headers[h].querySelectorAll('a[href$="/cart"], a[href*="/cart?"]');
      for (var i = 0; i < links.length; i++) found.push(links[i]);
    }
    return found;
  }

  function addCheckoutLabel() {
    var links = cartLinksInHeaders();

    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (link.getAttribute('data-btrs-labelled')) continue;
      if (link.querySelector('.btrs-cart-label')) continue;

      var label = document.createElement('span');
      label.className = 'btrs-cart-label';
      label.textContent = CART_LABEL;
      link.appendChild(label);
      link.setAttribute('data-btrs-labelled', 'true');
    }
  }

  function ensureMobileListLink() {
    var links = cartLinksInHeaders();
    var template = document.querySelector(VISIBLE_HOST_SELECTOR) ||
                   document.querySelector('[data-quote-count-host]');
    var cartCount = template ? (template.getAttribute('data-cart-count') || '0') : '0';

    for (var i = 0; i < links.length; i++) {
      var cartLink = links[i];
      var parent = cartLink.parentNode;
      if (!parent) continue;

      var previous = cartLink.previousElementSibling;
      if (previous && previous.hasAttribute && previous.hasAttribute('data-quote-mobile-link')) continue;

      var wrapper = document.createElement('a');
      wrapper.className = 'btrs-mobile-list';
      wrapper.href = LIST_URL;
      wrapper.setAttribute('data-quote-mobile-link', '');
      wrapper.setAttribute('data-quote-count-host', '');
      wrapper.setAttribute('data-cart-count', cartCount);
      wrapper.hidden = true;

      var text = document.createElement('span');
      text.className = 'btrs-mobile-list__text';
      text.textContent = LIST_LABEL;

      var badge = document.createElement('span');
      badge.className = 'btrs-mobile-list__count';
      badge.setAttribute('data-quote-count', '');
      badge.textContent = '0';

      wrapper.appendChild(text);
      wrapper.appendChild(badge);
      parent.insertBefore(wrapper, cartLink);
    }
  }

  function desktopListVisible() {
    var hosts = document.querySelectorAll(VISIBLE_HOST_SELECTOR);
    for (var i = 0; i < hosts.length; i++) {
      if (!hosts[i].hasAttribute('hidden') && isOnScreen(hosts[i])) return true;
    }
    return false;
  }

  function refreshCount() {
    var quoteQty = totalQuantity();

    var hosts = document.querySelectorAll('[data-quote-count-host]:not([data-quote-mobile-link])');
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      var cartQty = parseInt(host.getAttribute('data-cart-count'), 10) || 0;
      var total = cartQty + quoteQty;
      var badge = host.querySelector('[data-quote-count]');

      if (badge) badge.textContent = total;
      host.hidden = total === 0;
    }

    var onDesktop = desktopListVisible();
    var mobiles = document.querySelectorAll('[data-quote-mobile-link]');
    for (var m = 0; m < mobiles.length; m++) {
      var mobile = mobiles[m];
      var mobileCart = parseInt(mobile.getAttribute('data-cart-count'), 10) || 0;
      var mobileTotal = mobileCart + quoteQty;
      var mobileBadge = mobile.querySelector('[data-quote-count]');

      if (mobileBadge) mobileBadge.textContent = mobileTotal;
      mobile.hidden = onDesktop || mobileTotal === 0;
    }

    refreshPendingNotice(quoteQty);
    refreshOrderHold(quoteQty);
  }

  /* ----------------------------------------------- cart page: pending notice */

  function refreshPendingNotice(quoteQty) {
    var notice = document.querySelector('[data-quote-pending]');
    if (!notice) return;
    var count = notice.querySelector('[data-quote-pending-count]');
    if (count) count.textContent = quoteQty;
    notice.hidden = quoteQty === 0;
  }

  /* ------------------------------------------- request page: the hold notice */

  function refreshOrderHold(quoteQty) {
    var notice = document.querySelector('[data-quote-hold-notice]');
    var field = document.querySelector('[data-quote-action-field]');
    if (!notice && !field) return;

    var chosen = document.querySelector('input[name="contact[Request type]"]:checked');
    var isOrder = !!chosen && chosen.value.indexOf('PLACE AN ORDER') === 0;
    var applies = isOrder && quoteQty > 0;

    if (notice) notice.hidden = !applies;
    if (field) field.value = applies ? HOLD_INSTRUCTION : '';
  }

  function handleRequestTypeChange(event) {
    var input = event.target.closest('input[name="contact[Request type]"]');
    if (!input) return;
    refreshOrderHold(totalQuantity());
  }

  /* ---------------------------------------------------- product page buttons */

  function variantMapFor(button) {
    var scope = button.closest('[data-quote-gated]') || document;
    var node = scope.querySelector('[data-quote-variant-map]');
    if (!node) return {};
    try { return JSON.parse(node.textContent) || {}; } catch (e) { return {}; }
  }

  function currentVariantId(button) {
    var form = button.closest('form');
    if (form) {
      var field = form.querySelector('[name="id"]');
      if (field && field.value && field.value !== 'not-selected') return field.value;
    }
    return button.getAttribute('data-quote-default-variant') || '';
  }

  function currentQuantity(button) {
    var form = button.closest('form');
    if (!form) return 1;
    var field = form.querySelector('[name="quantity"]');
    if (!field) return 1;
    var value = parseInt(field.value, 10);
    return isNaN(value) || value < 1 ? 1 : value;
  }

  function confirmOnButton(button) {
    var label = button.querySelector('[data-quote-add-label]') || button;
    var original = button.getAttribute('data-quote-original-label');
    if (original === null) {
      original = label.textContent.trim();
      button.setAttribute('data-quote-original-label', original);
    }
    label.textContent = button.getAttribute('data-quote-added-label') || 'Added to your list';
    button.classList.add('is-added');
    window.clearTimeout(button._quoteResetTimer);
    button._quoteResetTimer = window.setTimeout(function () {
      label.textContent = original;
      button.classList.remove('is-added');
    }, 2600);
  }

  function handleAddClick(event) {
    var button = event.target.closest('[data-quote-add]');
    if (!button) return;
    event.preventDefault();

    var variantId = currentVariantId(button);
    if (!variantId) return;

    var variant = variantMapFor(button)[variantId] || {};

    addItem({
      id: variantId,
      title: button.getAttribute('data-quote-title') || '',
      variantTitle: variant.title && variant.title !== 'Default Title' ? variant.title : '',
      sku: variant.sku || '',
      url: button.getAttribute('data-quote-url') || '',
      qty: currentQuantity(button)
    });

    confirmOnButton(button);
  }

  /* ----------------------------------------------------------- submit guard */

  function blockGatedSubmits() {
    var wrappers = document.querySelectorAll('[data-quote-gated]');
    for (var i = 0; i < wrappers.length; i++) {
      var form = wrappers[i].closest('form');
      if (!form || form._quoteGuarded) continue;
      form._quoteGuarded = true;
      form.addEventListener('submit', function (event) { event.preventDefault(); });
    }
  }

  /* ------------------------------------------------------------------ money */

  function moneyFormat() {
    var node = document.querySelector('[data-quote-money-format]');
    var raw = node ? node.getAttribute('data-quote-money-format') : '';
    return raw || '${{amount}}';
  }

  function group(number, decimals, thousands, decimalMark) {
    var parts = Math.abs(number).toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.join(decimalMark);
  }

  function formatMoney(cents) {
    var value = (parseInt(cents, 10) || 0) / 100;
    var format = moneyFormat().replace(/<[^>]*>/g, '');

    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, group(value, 0, '.', ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, group(value, 2, '.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, group(value, 0, ',', '.'))
      .replace(/\{\{\s*amount\s*\}\}/g, group(value, 2, ',', '.'));
  }

  /* ------------------------------------------------------------- cart lines */

  function cartLineDescription(item) {
    var title = item.product_title || item.title || '';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      return title + ' - ' + item.variant_title;
    }
    return title;
  }

  function buildCartRow(item, index) {
    var row = document.createElement('tr');
    row.className = 'rq-line rq-line--cart';

    var qtyCell = document.createElement('td');
    qtyCell.className = 'rq-line__qty';
    var qtyInput = document.createElement('input');
    qtyInput.type = 'number';
    qtyInput.min = '1';
    qtyInput.step = '1';
    qtyInput.value = item.quantity;
    qtyInput.className = 'rq-qty-input';
    qtyInput.setAttribute('data-cart-qty-input', '');
    qtyInput.setAttribute('data-cart-line', String(index + 1));
    qtyInput.setAttribute('aria-label', 'Quantity for ' + cartLineDescription(item));
    qtyCell.appendChild(qtyInput);

    var itemCell = document.createElement('td');
    itemCell.className = 'rq-line__item';
    var link = document.createElement('a');
    link.href = item.url || '#';
    link.textContent = cartLineDescription(item);
    itemCell.appendChild(link);

    var skuCell = document.createElement('td');
    skuCell.className = 'rq-line__sku';
    skuCell.textContent = item.sku || '-';

    var priceCell = document.createElement('td');
    priceCell.className = 'rq-line__price';
    priceCell.textContent = formatMoney(item.line_price);

    var removeCell = document.createElement('td');
    removeCell.className = 'rq-line__remove';
    var removeButton = document.createElement('button');
    removeButton.type = 'button';
    removeButton.className = 'rq-remove-button';
    removeButton.textContent = 'Remove';
    removeButton.setAttribute('data-cart-remove', '');
    removeButton.setAttribute('data-cart-line', String(index + 1));
    removeButton.setAttribute('aria-label', 'Remove ' + cartLineDescription(item));
    removeCell.appendChild(removeButton);

    row.appendChild(qtyCell);
    row.appendChild(itemCell);
    row.appendChild(skuCell);
    row.appendChild(priceCell);
    row.appendChild(removeCell);

    return row;
  }

  function syncCartField(items) {
    var field = document.querySelector('[data-cart-items-field]');
    if (!field) return;
    field.value = items.map(function (item) {
      return item.quantity + ' x ' + cartLineDescription(item) +
        ' | SKU: ' + (item.sku || 'n/a');
    }).join('\n');
  }

  function renderCart(cart) {
    var rows = document.querySelector('[data-quote-cart-rows]');

    if (rows) {
      rows.innerHTML = '';
      (cart.items || []).forEach(function (item, index) {
        rows.appendChild(buildCartRow(item, index));
      });
    }

    syncCartField(cart.items || []);
    setAllCartCounts(cart.item_count || 0);

    refreshCount();
    refreshTotals(readList());
  }

  function changeCartLine(line, quantity) {
    var panel = document.querySelector('[data-quote-list-block]');
    if (panel) panel.setAttribute('aria-busy', 'true');

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart change failed');
        return response.json();
      })
      .then(function (cart) { renderCart(cart); })
      .catch(function () { window.location.reload(); })
      .then(function () {
        if (panel) panel.removeAttribute('aria-busy');
      });
  }

  function handleCartQtyChange(event) {
    var input = event.target.closest('[data-cart-qty-input]');
    if (!input) return;
    var line = parseInt(input.getAttribute('data-cart-line'), 10);
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 1) { qty = 1; input.value = 1; }
    changeCartLine(line, qty);
  }

  function handleCartRemove(event) {
    var button = event.target.closest('[data-cart-remove]');
    if (!button) return;
    event.preventDefault();
    changeCartLine(parseInt(button.getAttribute('data-cart-line'), 10), 0);
  }

  /* ------------------------------------------------------------ quote lines */

  function lineDescription(item) {
    return item.variantTitle ? item.title + ' - ' + item.variantTitle : item.title;
  }

  function buildRow(item) {
    var row = document.createElement('tr');
    row.className = 'rq-line rq-line--quote';

    var qtyCell = document.createElement('td');
    qtyCell.className = 'rq-line__qty';
    var qtyInput = document.createElement('input');
    qtyInput.type = 'number';
    qtyInput.min = '1';
    qtyInput.step = '1';
    qtyInput.value = item.qty;
    qtyInput.className = 'rq-qty-input';
    qtyInput.setAttribute('data-quote-qty-input', '');
    qtyInput.setAttribute('data-quote-id', item.id);
    qtyInput.setAttribute('aria-label', 'Quantity for ' + lineDescription(item));
    qtyCell.appendChild(qtyInput);

    var itemCell = document.createElement('td');
    itemCell.className = 'rq-line__item';
    if (item.url) {
      var link = document.createElement('a');
      link.href = item.url;
      link.textContent = lineDescription(item);
      itemCell.appendChild(link);
    } else {
      itemCell.textContent = lineDescription(item);
    }

    var skuCell = document.createElement('td');
    skuCell.className = 'rq-line__sku';
    skuCell.textContent = item.sku || '-';

    var priceCell = document.createElement('td');
    priceCell.className = 'rq-line__price rq-line__price--pending';
    priceCell.textContent = PRICE_PLACEHOLDER;

    var removeCell = document.createElement('td');
    removeCell.className = 'rq-line__remove';
    var removeButton = document.createElement('button');
    removeButton.type = 'button';
    removeButton.className = 'rq-remove-button';
    removeButton.textContent = 'Remove';
    removeButton.setAttribute('data-quote-remove', '');
    removeButton.setAttribute('data-quote-id', item.id);
    removeButton.setAttribute('aria-label', 'Remove ' + lineDescription(item));
    removeCell.appendChild(removeButton);

    row.appendChild(qtyCell);
    row.appendChild(itemCell);
    row.appendChild(skuCell);
    row.appendChild(priceCell);
    row.appendChild(removeCell);

    return row;
  }

  function syncHiddenField(items) {
    var field = document.querySelector('[data-quote-items-field]');
    if (!field) return;
    field.value = items.map(function (item) {
      return item.qty + ' x ' + lineDescription(item) +
        ' | SKU: ' + (item.sku || 'n/a') +
        ' | Price: to be confirmed';
    }).join('\n');
  }

  function renderQuotePage() {
    var rows = document.querySelector('[data-quote-list-rows]');
    if (!rows) return;
    var items = readList();
    rows.innerHTML = '';
    for (var i = 0; i < items.length; i++) rows.appendChild(buildRow(items[i]));
    syncHiddenField(items);
    refreshTotals(items);
  }

  function refreshTotals(items) {
    var counter = document.querySelector('[data-quote-total-count]');
    var block = document.querySelector('[data-quote-list-block]');
    var empty = document.querySelector('[data-quote-empty]');

    var quoteQty = sumQuantities(items);
    var cartQty = counter ? (parseInt(counter.getAttribute('data-cart-count'), 10) || 0) : 0;
    var total = cartQty + quoteQty;

    if (counter) counter.textContent = total + ' item' + (total === 1 ? '' : 's');
    if (block) block.hidden = total === 0;
    if (empty) empty.hidden = total > 0;
  }

  function handleQuotePageInput(event) {
    var input = event.target.closest('[data-quote-qty-input]');
    if (!input) return;
    setQuantity(input.getAttribute('data-quote-id'), input.value);
  }

  function handleQuotePageClick(event) {
    var button = event.target.closest('[data-quote-remove]');
    if (!button) return;
    event.preventDefault();
    removeItem(button.getAttribute('data-quote-id'));
  }

  /* -------------------------------------------------------- form persistence */

  function formFieldsIn(form) {
    return Array.prototype.filter.call(
      form.querySelectorAll('input[name], select[name], textarea[name]'),
      function (field) {
        var name = field.getAttribute('name') || '';
        if (name.indexOf('contact[') !== 0) return false;
        if (field.hasAttribute('data-quote-items-field')) return false;
        if (field.hasAttribute('data-cart-items-field')) return false;
        if (field.hasAttribute('data-quote-action-field')) return false;
        if (name === 'contact[Reference]') return false;
        if (name === 'contact[Source]') return false;
        return true;
      }
    );
  }

  function saveForm(form) {
    var data = { savedAt: Date.now(), values: {}, radios: {} };

    formFieldsIn(form).forEach(function (field) {
      var name = field.getAttribute('name');
      if (field.type === 'radio') {
        if (field.checked) data.radios[name] = field.value;
      } else if (field.type === 'checkbox') {
        data.values[name] = field.checked ? '1' : '';
      } else {
        data.values[name] = field.value;
      }
    });

    try { window.localStorage.setItem(FORM_KEY, JSON.stringify(data)); } catch (e) {}
  }

  function clearForm() {
    try { window.localStorage.removeItem(FORM_KEY); } catch (e) {}
  }

  function restoreForm(form) {
    var raw;
    try { raw = window.localStorage.getItem(FORM_KEY); } catch (e) { return; }
    if (!raw) return;

    var data;
    try { data = JSON.parse(raw); } catch (e) { clearForm(); return; }
    if (!data || !data.savedAt) { clearForm(); return; }

    if ((Date.now() - data.savedAt) / 86400000 > FORM_TTL_DAYS) { clearForm(); return; }

    formFieldsIn(form).forEach(function (field) {
      var name = field.getAttribute('name');
      if (field.type === 'radio') {
        if (data.radios && data.radios[name] === field.value) field.checked = true;
      } else if (field.type === 'checkbox') {
        if (data.values && name in data.values) field.checked = data.values[name] === '1';
      } else if (data.values && name in data.values && data.values[name] !== '') {
        field.value = data.values[name];
      }
    });
  }

  function initFormPersistence() {
    var form = document.querySelector('[data-quote-form-saved]');
    if (!form) return;

    restoreForm(form);

    var pending = null;
    var queueSave = function () {
      window.clearTimeout(pending);
      pending = window.setTimeout(function () { saveForm(form); }, 300);
    };

    form.addEventListener('input', queueSave);
    form.addEventListener('change', queueSave);
  }

  /* -------------------------------------------------------------- lifecycle */

  function refreshAll() {
    refreshCount();
    renderQuotePage();
  }

  function init() {
    document.addEventListener('click', handleAddClick);
    document.addEventListener('click', handleQuotePageClick);
    document.addEventListener('click', handleCartRemove);
    document.addEventListener('change', handleQuotePageInput);
    document.addEventListener('input', handleQuotePageInput);
    document.addEventListener('change', handleCartQtyChange);
    document.addEventListener('change', handleRequestTypeChange);
    document.addEventListener('submit', rememberSubmit);

    blockGatedSubmits();
    addCheckoutLabel();
    ensureMobileListLink();

    if (!clearEverythingAfterSubmit()) {
      initFormPersistence();
    }

    refreshAll();

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        ensureMobileListLink();
        refreshCount();
      }, 150);
    });

    window.addEventListener('storage', function (event) {
      if (event.key === STORAGE_KEY) refreshAll();
    });
  }

  window.BacktrackQuoteList = {
    get: readList,
    add: addItem,
    remove: removeItem,
    setQuantity: setQuantity,
    count: totalQuantity,
    refresh: refreshAll,
    clearSavedForm: clearForm
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
